module.exports = __webpack_public_path__ + "img/myApprovalMyico@2x.9a210068.png";